import React, { Component } from "react";
import { Container, Row, Col, Button } from "design-react-kit";
import { utilsService } from "libs";
import { MSelect } from "./MSelect";
import { MInput } from "./MInput";
import { MToggle } from "./MToggle";

export class MSearchAteneo extends Component {
  PAYLOADS = {
    regions: [],
    ateneo: [],
  };

  state = {
    regionOptions: { options: [{ label: "Seleziona", value: -1 }] },
    ateneoOptions: { options: [{ label: "Seleziona", value: -1 }] },
    actionModule: false,
    istitutionData: false,
    foreignData: { nation: "", city: "", istitution: "" },
    isForeign: false,
  };

  //--- ---

  componentDidMount() {
    this.loadRegions();
  }

  loadRegions = () => {
    utilsService
      .regions()
      .then(({ data }) => {
        const { payload } = data;
        const regions = payload.regions.map(({ codReg, denReg }) => ({
          label: denReg,
          value: codReg,
        }));

        this.PAYLOADS.regions = [];
        this.PAYLOADS.regions.push({ label: "Seleziona", value: -1 });
        this.PAYLOADS.regions.push(...regions);

        this.setState({
          regionOptions: { options: this.PAYLOADS.regions },
        });
      })
      .catch((errors) => {
        console.log(errors);
      });
  }; //loadRegions

  loadAteneo = (_, value) => {
    if (value === "-1" || value === "") {
      this.setState({
        ateneoOptions: { options: [{ label: "Seleziona", value: -1 }] },
        actionModule: false,
      });
      return;
    }

    this.getAteneoOptions(value);
  }; //loadAteneo

  getAteneoOptions(codReg) {
    const { type } = this.props;

    utilsService
      .universitiesByCodRegType(codReg, type)
      .then(({ data }) => {
        const { payload } = data;
        const ateneo = payload.universities.map(({ uniCode, name, city }) => ({
          label: name,
          value: [uniCode, city, name],
        }));

        this.setState({
          ateneoOptions: {
            options: [{ label: `Seleziona (${ateneo.length})`, value: -1 }, ...ateneo],
          },
        });
      })
      .catch((errors) => {
        console.log(errors);
      });
  }

  prepareDataToSend = (_, value) => {
    if (value === "-1") {
      this.setState({ actionModule: false, istitutionData: null });
    } else {
      this.setState({
        istitutionData: value.split(","),
        actionModule: true,
      });
    }
  }; //prepareDataToSend

  onChangeIsForeign = () => {
    this.setState((prevState) => ({
      isForeign: !prevState.isForeign,
      actionModule: false,
      istitutionData: null,
      ateneoOptions: { options: [{ label: "Seleziona", value: -1 }] },
      foreignData: { nation: "", city: "", istitution: "" },
    }));
  };

  onChangeForeignInput = (id, value) => {
    this.setState((prevState) => {
      const updatedForeignData = {
        ...prevState.foreignData,
        [id]: value,
      };

      const { nation, city, istitution } = updatedForeignData;
      const isFormValid = nation.trim() !== "" && city.trim() !== "" && istitution.trim() !== "";

      return {
        foreignData: updatedForeignData,
        actionModule: isFormValid,
      };
    });
  };

  handleChange = () => {
    if (this.props.onChange) {
      const { isForeign, foreignData, istitutionData } = this.state;
      const data = isForeign
        ? { ...foreignData }
        : {
            nation: "Italia",
            uniCode: istitutionData[0],
            city: istitutionData[1],
            istitution: istitutionData[2],
          };

      this.props.onChange(data);
      this.props.searchAteneo();
    }
  };

  render() {
    const { regionOptions, ateneoOptions, actionModule, isForeign } = this.state;

    return (
      <>
        <Container className="m-0 p-0">
          <Row>
            <Col lg={12} className="mb-4">
              <div className="col-lg-6 col-md-6">
                <MToggle name="isForeign" id="isForeign" label="Titolo conseguito presso Università Estera?" onChange={this.onChangeIsForeign} />
              </div>
            </Col>
          </Row>

          <p className="pb-4">{isForeign ? "Inserire i dati dell'università estera." : "Selezionare l'Università dove hai conseguito il Titolo."}</p>
          <Row>
            {!isForeign ? (
              <>
                <Col lg={5} className="mb-1">
                  <div className="bootstrap-select-wrapper">
                    <MSelect id="region" label="Regione" payload={regionOptions} onChange={this.loadAteneo} />
                  </div>
                </Col>

                <Col lg={7} className="mb-1">
                  <div className="bootstrap-select-wrapper">
                    <MSelect id="istitution" label="Università" payload={ateneoOptions} onChange={this.prepareDataToSend} />
                  </div>
                </Col>
              </>
            ) : (
              <>
                <Col lg={6} className="mb-3">
                  <MInput label="Nazione" id="nation" name="nation" onChange={this.onChangeForeignInput} type="text" />
                </Col>
                <Col lg={6} className="mb-3">
                  <MInput label="Città" id="city" name="city" onChange={this.onChangeForeignInput} type="text" />
                </Col>
                <Col lg={8} className="mb-3">
                  <MInput label="Università" id="istitution" name="istitution" onChange={this.onChangeForeignInput} type="text" />
                </Col>
              </>
            )}

            <Col lg={12} className="m-0 text-right">
              <Button
                color="primary bg-dark"
                disabled={!actionModule}
                size="md"
                onClick={() => {
                  this.handleChange();
                }}
              >
                SELEZIONA
              </Button>

              <Button
                color="primary"
                className="mx-5"
                outline
                size="md"
                onClick={() => {
                  this.props.searchAteneo();
                }}
              >
                ANNULLA
              </Button>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
